import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import SideBar from '../usercomponents/SideBar';
import TopNavBar from '../usercomponents/TopNavBar';
import Footer from '../usercomponents/Footer';

const apiUrl = process.env.REACT_APP_API_URL;

function formatDateDisplay(dateStr) {
  if (!dateStr) return { day: '', weekday: '', month: '' };
  const d = new Date(dateStr);
  return {
    day: d.toLocaleDateString('en-IN', { day: '2-digit', timeZone: 'UTC' }),
    weekday: d.toLocaleDateString('en-IN', { weekday: 'short', timeZone: 'UTC' }),
    month: d.toLocaleDateString('en-IN', { month: 'short', year: 'numeric', timeZone: 'UTC' }),
  };
}

function StudentMyAttendance() {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchRecords = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const sessionData = JSON.parse(sessionStorage.getItem('studentSession'));
      const response = await axios.get(`${apiUrl}/api/student/my-attendance`, {
        headers: { Authorization: `Bearer ${sessionData?.token}` },
      });
      if (response.data.success) {
        setRecords(response.data.records || []);
      } else {
        setError(response.data.message || 'Failed to fetch attendance.');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Error fetching attendance.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchRecords();
  }, [fetchRecords]);

  return (
    <>
      <SideBar />
      <div className="dashboard-main-wrapper">
        <TopNavBar />
        <div className="dashboard-body px-3">
          <div className="breadcrumb mb-24">
            <ul className="d-flex align-items-center gap-2 list-unstyled">
              <li><Link to="/dashboard" className="text-gray-200 text-15 hover-text-main-600 text-decoration-none">Home</Link></li>
              <li><span className="text-gray-500 d-flex align-items-center"><i className="ph ph-caret-right" /></span></li>
              <li><span className="text-main-600 text-15">My Attendance</span></li>
            </ul>
          </div>

          {error && <div className="alert alert-danger mb-20">{error}</div>}

          <div className="card shadow-sm border-0">
            <div className="card-body p-4">
              <div className="d-flex justify-content-between align-items-center mb-24">
                <h4 className="mb-0 text-main-600 fw-bold">My Attendance</h4>
                <span className="text-13 text-gray-400">{records.length} day{records.length === 1 ? '' : 's'} marked</span>
              </div>

              {loading ? (
                <div className="text-center py-40"><div className="spinner-border text-main-600" /></div>
              ) : records.length === 0 ? (
                <div className="text-center py-40 text-gray-400">
                  <i className="ph ph-calendar-x" style={{ fontSize: 40 }} />
                  <p className="mt-8 mb-0">No attendance marked yet.</p>
                </div>
              ) : (
                <div className="d-flex flex-column gap-12">
                  {records.map((r, idx) => {
                    const { day, weekday, month } = formatDateDisplay(r.attendance_date);
                    return (
                      <div
                        key={idx}
                        className="d-flex align-items-center gap-16 p-16"
                        style={{ background: '#f6faf8', borderRadius: 14, border: '1px solid #e8f5ee' }}
                      >
                        <div
                          className="d-flex flex-column align-items-center justify-content-center flex-shrink-0"
                          style={{ width: 60, height: 60, borderRadius: 12, background: '#0f9d58', color: '#fff' }}
                        >
                          <span style={{ fontSize: 20, fontWeight: 800, lineHeight: 1 }}>{day}</span>
                          <span style={{ fontSize: 11, fontWeight: 600, textTransform: 'uppercase' }}>{weekday}</span>
                        </div>
                        <div className="flex-grow-1">
                          <div className="fw-semibold text-15">{month}</div>
                          <div className="text-13 text-gray-500">Marked present</div>
                        </div>
                        <div className="text-end">
                          <div className="fw-semibold text-15 text-main-600">{r.marked_at_display}</div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}

export default StudentMyAttendance;
